import { Card as CardType, WildcardTypes } from "../types";

interface WildCard extends CardType {
  activity: WildcardTypes | "other";
}

export const WILD_CARDS: WildCard[] = [
  {
    description: "For the group: Never have I ever had a threesome.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever had a one night stand.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever had sex in a car.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever had sex in public.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description:
      "For the group: Never have I ever had sex with someone I met on a dating app.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description:
      "For the group: Never have I ever had sex with someone I worked with.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description:
      "For the group: Never have I ever had sex with someone I met at a party.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description:
      "For the group: Never have I ever had sex with someone I met at a bar.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description:
      "For the group: Never have I ever had sex with someone I met at a club.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description:
      "For the group: Never have I ever had sex with someone I met on vacation.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description:
      "For the group: Never have I ever had sex with someone I met at a concert.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description:
      "For the group: Never have I ever had sex with someone I met at a sports event.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description:
      "For the group: Never have I ever had sex with someone I met at a wedding.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description:
      "For the group: Never have I ever had sex with someone I met at a funeral.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever peed in public.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description:
      "For the group: Never have I ever pooped my pants as an adult.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description:
      "For the group: Never have I ever needed someone to help me while drunk.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever thrown up in someone's car.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever passed out in public.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever peed the bed as an adult.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description:
      "For the group: Never have I ever thrown up in a public place.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever needed to be carried home.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever thrown up in a bar.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever peed in a pool.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever thrown up in a club.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description:
      "For the group: Never have I ever needed someone to help me walk.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever thrown up in a restaurant.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever peed in a shower.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever thrown up in a taxi.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever stolen from a store.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever lied to get out of work.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever cheated on a test.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description:
      "For the group: Never have I ever pretended to be sick to skip school.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description:
      "For the group: Never have I ever lied about my age to get into a club.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever used a fake ID.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever snuck into a movie theater.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever snuck into a concert.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever snuck into a club.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever snuck into a bar.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever snuck into a sports event.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever snuck into a theme park.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever snuck into a museum.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever snuck into a zoo.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },
  {
    description: "For the group: Never have I ever snuck into a pool.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink2",
    pub: true,
  },

  {
    description: "Change places! All of the group change seats, draw again!",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "seats",
    pub: true,
  },
  {
    description:
      "Waterfall! All drink, each person can stop when the person to their left stops.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink4",
    pub: true,
  },
  {
    description:
      "Suck and blow around the group! Suck a card to your lips and pass it on to the lips on your left. (Stops when it drops)",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink4",
  },
  {
    description:
      "Say a celeb. The next person says a celeb starting with the first letter of the surname. Person that messes up drinks.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink4",
    pub: true,
  },

  {
    description:
      "Switch with the person 2 places ahead of you. It's now their turn.",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "seats",
    pub: true,
  },
  {
    description:
      "Switch with the person 4 places ahead of you. It's now their turn.",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "seats",
    pub: true,
  },
  {
    description:
      "Switch with the person 6 places ahead of you. It's now their turn.",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "seats",
    pub: true,
  },
  {
    description:
      "Start a dirty pint for the group. At the start of each persons go they add to the pint. The next person to forfeit a card has to drink it. Now draw again!",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "other",
    pub: true,
  },
  {
    description:
      "Going around to the left, the 2nd, 4th, 6th and 8th person adds to a dirty pint. The next person to forfeit a card has to drink it. Now draw again!",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "other",
    pub: true,
  },
  {
    description:
      "Sharing is caring! Any clothes that are unworn must be put by the person currently furthest away from that item. (1 item per person)",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "other",
  },

  {
    description: "Everybody up! You're playing roxanne!",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "spin",
    pub: true,
  },
  {
    description: "Everyone stand on one leg! First to fall loses!",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "other",
    pub: true,
  },
  {
    description:
      "Change places! All of the group change seats, and draw again!",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "seats",
    pub: true,
  },
  {
    description:
      "Get out of jail free! Use this to forfeit a future card. Now draw again!",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "jail",
    pub: true,
  },
  {
    description: "Each person gives an item of clothing to the left. ",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "other",
  },
  {
    description: "Each person gives an item of clothing to the right. ",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "other",
  },
  {
    description:
      "Switch with the person 3 places ahead of you. It's now their turn.",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "seats",
    pub: true,
  },
  {
    description:
      "Switch with the person 5 places ahead of you. It's now their turn.",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "seats",
    pub: true,
  },
  {
    description:
      "Switch with the person 7 places ahead of you. It's now their turn.",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "seats",
    pub: true,
  },
  {
    genre: "wildcard",
    activity: "group",
    description:
      "Go around the group and say an outrageous pickup line. 10 seconds limit. Anyone who passes or says the worst one drinks.",
    penaltyCost: 1,
    pub: true,
  },
  {
    genre: "wildcard",
    activity: "other",
    description:
      "Everyone points at one person to dare to remove an item of clothing. Majority rules.",
    penaltyCost: 5,
  },
  {
    genre: "wildcard",
    activity: "other",
    description:
      "Everyone points at one person to dare to remove 2 items of clothing. Majority rules.",
    penaltyCost: 5,
  },
  {
    genre: "wildcard",
    activity: "other",
    description:
      "Create a rule that everyone must follow until your next turn.",
    penaltyCost: 1,
    pub: true,
  },
  {
    genre: "wildcard",
    activity: "other",
    description: "Create a rule involving something risqué.",
    penaltyCost: 1,
  },
  {
    genre: "wildcard",
    activity: "other",
    description: "Everyone around the group plays spin the bottle!",
    penaltyCost: 3,
    pub: true,
  },

  {
    description:
      "Everyone point to the person most likely to become a pornstar Highest votes drinks.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink",
    pub: true,
  },
  {
    description: "Everyone point to the biggest pussy. Highest votes drinks.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink",
    pub: true,
  },
  {
    description: "Floor is lava. Last person to leave the floor drinks.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink5",
    pub: true,
  },
  {
    description: "Point at someone they drink this with you.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink",
    pub: true,
  },
  {
    description: "No getting out of it, drink this.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink",
    pub: true,
  },
  {
    description:
      "Thumbmaster, place thumb on table, last person to notice drinks.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "other",
    pub: true,
  },
  {
    description: "Boys drink.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink",
    pub: true,
  },
  {
    description: "Girls drink.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink",
    pub: true,
  },
  {
    description: "Last person to raise hand drinks.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink5",
    pub: true,
  },
  {
    description:
      "Say a word and a rhyme goes around the circle. Person that messes up drinks.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink5",
    pub: true,
  },
  {
    description:
      "Say a category and goes around the circle. Person that messes up drinks.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "group",
    pub: true,
  },
  {
    description:
      "Announce you are questionmaster. Ends when someone replies to your question, and they drink.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink5",
    pub: true,
  },
  {
    description: "People with the bodycount higher than 3, drink.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink3",
    pub: true,
  },
  {
    description: "People with peircings, drink.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink3",
    pub: true,
  },

  {
    description: "People with non visable peircings, drink.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink3",
    pub: true,
  },
  {
    description: "People with tattoos, drink.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink3",
    pub: true,
  },
  {
    description: "People with the bodycount lower than 3 drink.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink3",
    pub: true,
  },
  {
    description: "People without peircings, drink.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink3",
    pub: true,
  },
  {
    description: "People without tattoos, drink.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink3",
    pub: true,
  },

  {
    description: "Switch seats with someone of the group's choosing.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "seats",
    pub: true,
  },

  {
    description:
      "Group activity: Spell out the work DICK on the floor with your bodies.",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "group",
  },

  {
    description:
      "Group activity: Hide from the camera! Someone spins with a 10 second countdown timer. Anyone in frame drinks.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "group",
  },

  {
    description:
      "Pass a snack around the group however you want. First person who drops it drinks.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "group",
  },

  {
    description:
      "For the group: Until your next turn ends, all cards have their penalty cost doubled.",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "group",
  },

  {
    description:
      "For the group: Until your next turn ends, all cards penalty costs are now items of clothing.",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "group",
  },

  {
    description: "Everyone pass an item of clothing to the left.",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "group",
  },

  {
    description: "Everyone pass an item of clothing to the right.",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "group",
  },

  {
    description: "Everyone pass 2 unqiue items of clothing to the left.",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "group",
  },
  {
    description: "Everyone pass 2 unqiue items of clothing to the right.",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "group",
  },
  {
    description: "Everyone pass 3 unqiue items of clothing to the left.",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "group",
  },
  {
    description: "Everyone pass 3 unqiue items of clothing to the right.",
    penaltyCost: 0,
    genre: "wildcard",
    activity: "group",
  },

  {
    description: "People with glasses, drink.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink3",
    pub: true,
  },
  {
    description: "People without glasses, drink.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink3",
    pub: true,
  },

  {
    description: "People with a beard, drink.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink3",
    pub: true,
  },
  {
    description: "People without a beard, drink.",
    penaltyCost: 1,
    genre: "wildcard",
    activity: "drink3",
    pub: true,
  },
];
